
export const boardPageStyles = {
  headline: {
    paddingTop: "2rem",
    textAlign: "center",
  },
  outerContainer: {
    overflowX: "auto",
    height: "calc(100vh - 96px)",
  },
  outerContainerWithTechStatus: {
    overflowX: "auto",
    height: "calc(100vh - 148px)",
  },
};
